// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tYzr","largestCol":"styles_largestCol__3C1RW","smallestCol":"styles_smallestCol__3cxtf"};